import { render, staticRenderFns } from "./ReportNeqasOverdueComponent.vue?vue&type=template&id=cd5123a2&scoped=true"
import script from "./ReportNeqasOverdueComponent.vue?vue&type=script&lang=js"
export * from "./ReportNeqasOverdueComponent.vue?vue&type=script&lang=js"
import style0 from "./ReportNeqasOverdueComponent.vue?vue&type=style&index=0&id=cd5123a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5123a2",
  null
  
)

export default component.exports